import { List } from '@material-ui/core'
import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles'
import classNames from 'classnames'
import upperFirst from 'lodash/upperFirst'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Provider, Stops } from 'src/api/gen'

import { enumsTranslationKeys } from '../i18nEnums'

interface IProps extends WithStyles<typeof styles> {
  provider?: Provider
  stop: Stops
}

const StopPopup = (props: IProps) => {
  const { t } = useTranslation()

  return (
    <div className={props.classes.root}>
      <div style={{ width: '100%' }}>
        <div className={props.classes.row}>
          <div className={props.classes.header}>
            <div className={props.classes.stopsTitle}>{props.stop.name}</div>
            <div className={props.classes.row} style={{ height: 5 }} />
            <List>
              {props.stop.line_names
                ? JSON.parse(props.stop.line_names.toString()).map((name: string, index: number) => (
                    <div key={index} className={props.classes.stopsSubTitle}>
                      {name}
                    </div>
                  ))
                : undefined}
            </List>
            <div className={props.classes.row} style={{ height: 5 }} />
            <div className={classNames(props.classes.row, props.classes.stopsProvider)}>
              {t('Line Type') + ' : '}
              {upperFirst(t(enumsTranslationKeys.LineType[(props.stop.line_type as string) ?? '']))}
            </div>
          </div>
        </div>
        <div className={props.classes.row} style={{ height: 10 }} />
        <div className={props.classes.row}></div>
      </div>
    </div>
  )
}

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      minWidth: 320,
      padding: '4px',
    },
    media: {
      textAlign: 'center',
      minHeight: 80,
      minWidth: 80,
      marginLeft: theme.spacing(),
      backgroundSize: 'contain',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    },
    header: {
      cursor: 'pointer',
    },
    stopsTitle: {
      fontSize: '18px',
      lineHeight: '20px',
      fontWeight: 'bold',
    },
    stopsSubTitle: {
      fontSize: '15px',
      lineHeight: '20px',
      color: theme.palette.grey[500],
    },
    stopsProvider: {
      fontSize: 15,
      color: theme.palette.grey[500],
    },
    row: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    column: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    vertLine: {
      height: 100,
      width: 2,
      background: '#e8e7e7',
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
  })

export default withStyles(styles)(StopPopup)
